import { UnitType } from '@exodus/currency'

const name = 'filecoin'
const displayName = 'Filecoin'
const ticker = 'FIL'
const displayTicker = 'FIL'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#0090FF'
const gradientColors = ['#3BBFCC', '#0090FF']
const gradientCoords = { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  attoFIL: 0,
  nanoFIL: 9,
  FIL: 18,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://filfox.io/en/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://filfox.io/en/message/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Filecoin is a decentralized storage network designed to store humanity’s most important information.',
  reddit: 'https://www.reddit.com/r/filecoin/',
  twitter: 'https://twitter.com/Filecoin',
  website: 'https://filecoin.io/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
